import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"setting-fab",staticStyle:{"top":"calc(54% + 50px)"},attrs:{"small":"","fab":"","dark":"","falt":"","fixed":"","right":"","color":"blue"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c(VIcon,[_vm._v("mdi-message-alert-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }